import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-[#0B0B0B] border-t border-white/10 text-white py-12 mt-auto" data-id="element-562">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-563">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-564">
          <div className="col-span-1 md:col-span-2" data-id="element-565">
            <div className="flex items-center gap-2 mb-4" data-id="element-566">
              <div className="w-8 h-8 bg-[#C9A34E] rounded-lg flex items-center justify-center" data-id="element-567">
                <span className="text-[#0B0B0B] font-bold text-lg leading-none" data-id="element-568">
                  N
                </span>
              </div>
              <span className="font-bold text-xl tracking-tight text-white" data-id="element-569">
                NOIZA
              </span>
            </div>
            <p className="text-white/40 max-w-sm mb-6" data-id="element-570">
              El marketplace gastronómico de Los Santos. Descubre, ordena y
              disfruta de los mejores restaurantes de la zona en un solo lugar.
            </p>
          </div>

          <div data-id="element-571">
            <h4 className="font-semibold text-white mb-4" data-id="element-572">Explorar</h4>
            <ul className="space-y-3" data-id="element-573">
              <li data-id="element-574">
                <Link to="/" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-575">
                  Inicio
                </Link>
              </li>
              <li data-id="element-576">
                <Link to="/restaurants" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-577">
                  Restaurantes
                </Link>
              </li>
              <li data-id="element-578">
                <Link to="/cart" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-579">
                  Carrito
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-580">
            <h4 className="font-semibold text-white mb-4" data-id="element-581">Para Restaurantes</h4>
            <ul className="space-y-3" data-id="element-582">
              <li data-id="element-583">
                <a href="#" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-584">
                  Únete a NOIZA
                </a>
              </li>
              <li data-id="element-585">
                <a href="#" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-586">
                  Portal de Socios
                </a>
              </li>
              <li data-id="element-587">
                <a href="#" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-588">
                  Soporte
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-589">
          <p className="text-white/30 text-sm" data-id="element-590">
            © {new Date().getFullYear()} NOIZA. Todos los derechos reservados.
            Los Santos, Costa Rica.
          </p>
          <div className="flex gap-4" data-id="element-591">
            <a href="#" className="text-white/30 hover:text-[#C9A34E] text-sm transition-colors" data-id="element-592">
              Términos
            </a>
            <a href="#" className="text-white/30 hover:text-[#C9A34E] text-sm transition-colors" data-id="element-593">
              Privacidad
            </a>
          </div>
        </div>
      </div>
    </footer>;
}